
import { Component, Prop, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import OverlayModule from "@/store/modules/overlay.module";
import { PromotionPlans } from "@/models/entities/subscription-plan.interface";
import { userService } from "@/services/api/user.service";
import { paymentsService } from "@/services/api/payments.service";

const overlayModule = getModule(OverlayModule, store);

@Component
export default class SubscriptionPlan extends Vue {
  private downgrade = false;
  private subscriptionPlan: PromotionPlans = {
    offertID: 0,
    nameOffert: "",
    descrOffert: "",
    price: "",
    monthlyBeneficiaries: "",
    totalSubjects: "",
    firstSupport: false,
    secondSupport: false,
    freeTrial: "",
    expiration: "",
    roleId: 0,
    priceMonthID: "",
    priceYearID: "",
    yearPrice: "",
  };

  private subscriptionExpired = false;

  @Prop({ type: String, default: "", required: false })
  private addTitle: string;

  @Prop({ type: Boolean, default: false, required: false })
  private cancelledPlan: boolean;

  async created(): Promise<void> {
    overlayModule.showOverlay();
    this.downgrade = (await paymentsService.GetChangedPlan()).data;
    this.subscriptionPlan = (await userService.GetSubscription()).data;
    const parse = this.subscriptionPlan.expiration.split("/");
    this.subscriptionExpired =
      new Date(parse[1] + "/" + parse[0] + "/" + parse[2]).getTime() <
      new Date().getTime();
  }
}
